import script from "./ApplicationDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationDetailsPage.vue?vue&type=style&index=0&id=41f12f85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f12f85"]])

export default __exports__